/**
 * Mehrere Frontoffice-User je Kontakt (28.09.2026).
 *
 * Das Backend führt `foUserId` (primärer FO) und `foUserIds` (alle FO, erster =
 * primärer). Im Formularzustand (`FormState`, nur Skalare) steht die Liste als
 * kommagetrennte Zeichenkette unter `foUserIds`; `foUserId` spiegelt immer den
 * ersten Eintrag, damit alle bestehenden Pfade (Pflichtregel „FO oder BO",
 * Sub-Kontakt-Vererbung, Anlage-Payload) unverändert weiterlaufen.
 */

/** Liste aus Array oder kommagetrennter Zeichenkette — getrimmt, ohne Leere und Dubletten. */
export function foListe(v: unknown): string[] {
  const roh = Array.isArray(v)
    ? v
    : typeof v === "string"
      ? v.split(",")
      : [];
  const aus = roh
    .map((x) => (typeof x === "string" ? x.trim() : ""))
    .filter(Boolean);
  return [...new Set(aus)];
}

/** FO-Liste aus einem Formularzustand; ohne `foUserIds` gilt `foUserId`. */
export function foListeAusForm(f: Record<string, unknown> | null | undefined): string[] {
  if (!f) return [];
  const liste = foListe(f.foUserIds);
  const primaer = typeof f.foUserId === "string" ? f.foUserId.trim() : "";
  if (liste.length > 0 && (!primaer || liste[0] === primaer)) return liste;
  return primaer ? [primaer] : [];
}

/**
 * Wirksame FO-Liste eines geladenen Kontakts — dieselbe Regel wie im Backend
 * (`rbac/foUserIds.ts`): Die Liste zählt nur, wenn ihr erster Eintrag der
 * primäre FO ist.
 */
export function foListeAusKontakt(
  c: { foUserId?: string | null; ownerUserId?: string | null; foUserIds?: string[] | null } | null | undefined,
): string[] {
  if (!c) return [];
  const primaer = (c.foUserId ?? c.ownerUserId ?? "").trim();
  if (!primaer) return [];
  const liste = foListe(c.foUserIds);
  return liste.length > 0 && liste[0] === primaer ? liste : [primaer];
}

/** Eintrag an-/abwählen; Reihenfolge bleibt, Neues hinten (erster bleibt primär). */
export function foUmschalten(liste: string[], id: string): string[] {
  return liste.includes(id) ? liste.filter((x) => x !== id) : [...liste, id];
}
